import { Button, useTheme } from "@heroui/react";
import { Moon, Sun } from "@gravity-ui/icons";
import { nextTheme, persistTheme, type Theme } from "./theme";

function ThemeIcon({ name }: { name: "sun" | "moon" }) {
  const Icon = name === "sun" ? Sun : Moon;
  return <Icon className="size-4" />;
}

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme("system");
  const current: Theme = resolvedTheme === "dark" ? "dark" : "light";

  return (
    <Button
      isIconOnly
      size="sm"
      variant="tertiary"
      aria-label="Ganti tema"
      onPress={() => {
        const next = nextTheme(current);
        setTheme(next);
        persistTheme(next);
      }}
    >
      <ThemeIcon name={current === "dark" ? "sun" : "moon"} />
    </Button>
  );
}
